import React from "react";
import styles from "./RelatedIncidentItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

/**
 * Interactive component.
 * Displays the information of an incident.
 * Clicking on the incident number will take the user to the incident details page.
 * Clicking on the IBO number will take the user to the IBO file page
 */
export function RelatedIncidentItem({
  index,
  IncidentDetails,
  onClick,
  onIboClick,
}) {
  const shortNumber = IncidentDetails.number.substring(0, 8) + "...";
  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
    >
      <div>
        <Link to={`/security/incident/${IncidentDetails.number}`}>
          <div className={styles.link} onClick={onClick}>
            {shortNumber}
          </div>
        </Link>
      </div>
      <div>{IncidentDetails.status}</div>
      <div>{IncidentDetails.type}</div>
      <div>{IncidentDetails.severity}</div>
      <div>{IncidentDetails.dateCreated}</div>
    </div>
  );
}

RelatedIncidentItem.propTypes = {
  /**
   * Determines the background color of the item.
   * If odd, background is #EFEFEF.
   */
  index: PropTypes.number,
  /**
   * Object with details about the incident.
   */
  IncidentDetails: PropTypes.shape({
    number: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    severity: PropTypes.string,
    iboNum: PropTypes.string,
    caseOwner: PropTypes.string,
    dateCreated: PropTypes.string,
  }),
  /**
   * Function called when the incident number is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function called when the IBO number is clicked.
   */
  onIboClick: PropTypes.func,
};
